import React from 'react';
import {Modal} from 'react-spaceship-web';
export default class RenderV1Page extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			is_loading: true,
			url: props.url || {},
		};
	}

	componentDidMount() {

	}

	render() {
		return (
			<div>
				<Modal onShow={(ref) => {
					const iframe = window.$(ref).find('iframe').get(0)
					window.$(ref).find('iframe')
						.attr('src', this.state.url)
						.parent().css({
						position: 'relative'
					})
					iframe.addEventListener("load", function () {
						setTimeout(() => {
							window.$(iframe).contents().find(".slide-menu-root").remove();
						}, 500)
					})

					window.$(ref).find('.close-modal-button').on('click', () => {
						window.$(ref).find('.icon.close').trigger('click')
					})

					window.$(ref).find('#unselect-button').on('click', () => {
						window.$(ref).find('.icon.close').trigger('click')
						this.props.onSelect(false)
					})
					window.$(ref).find('#select-button').on('click', () => {
						window.$(ref).find('.icon.close').trigger('click')
						this.props.onSelect(true)
					})
				}}
				       className={'ui large modal min-h-[95%] relative'}
				       closable={true}
				       onApprove={(ref) => {
					       return false;
				       }}
				>
					<div
						className={'close-modal-button absolute top-0 left-0 w-full bg-red-500 text-white text-center py-3'}>โปรดใช้หน้าต่างนี้เพื่อจุดประสงค์ <u>ดูข้อมูลเท่านั้น</u> การใช้งานฟังก์ชั่นจากหน้านี้ระบบอาจทำงานไม่ถูกต้อง <u
						className={'cursor-pointer'}>ปิดหน้าต่าง</u></div>
					<iframe className={'w-full h-full'} frameBorder={0} title={'Quick View B49erp'}></iframe>
					{
						this.props.onSelect
						&&
						<div className={'absolute bottom-0 left-0 w-full z-10 bg-white'}>
							<div className={'p-3 grid grid-cols-3 gap-4'}>
								<div className={'ui button basic'}
								     id={'unselect-button'}
								>
									ไม่เลือก
								</div>
								<div className={'ui button basic'}
								     id={'select-button'}
								>
									เลือก
								</div>
								<div className={'close-modal-button ui button blue'}>
									ปิดหน้าต่าง
								</div>
							</div>
						</div>
					}
				</Modal>
			</div>
		);
	}
}
